import axios from "axios";

const REST_STOP_URI_PREFIX = "/dt/admin/v1/rest-stop";
export const REST_STOP_URIS = {
  GET_LIST_REST_STOP: `${REST_STOP_URI_PREFIX}/list`,
  GET_REST_STOP_DETAIL: (id) => `${REST_STOP_URI_PREFIX}/${id}`,
  GET_LIST_HISTORY_REST_STOP: `${REST_STOP_URI_PREFIX}/history`,
  ADD_REST_STOP: `${REST_STOP_URI_PREFIX}`,
  EDIT_REST_STOP: (id) => `${REST_STOP_URI_PREFIX}/${id}`,
  EXPORT_LIST_REST_STOP: `${REST_STOP_URI_PREFIX}/export`,
  IMPORT_CONTINUE: `${REST_STOP_URI_PREFIX}/import/confirm`,
  SET_STATUS: (restStopId) =>
    `${REST_STOP_URI_PREFIX}/${restStopId}/update-status`,
  GET_IMPORT_PROGRESS: (importId) =>
    `${REST_STOP_URI_PREFIX}/import-progress?importId=${importId}`,
  IMPORT: `${REST_STOP_URI_PREFIX}/import`,
  GET_CONFIRM_NEEDED_LIST: (confirmId) =>
    `${REST_STOP_URI_PREFIX}/import/confirm/${confirmId}`,
  DOWNLOAD_ERROR_FILE: (errorId) =>
    `${REST_STOP_URI_PREFIX}/import/error/${errorId}`,
};

export default {
  getListRestStop(params, signal) {
    return axios.get(REST_STOP_URIS.GET_LIST_REST_STOP, { params, signal });
  },
  getRestStopDetailById(id) {
    return axios.get(REST_STOP_URIS.GET_REST_STOP_DETAIL(id));
  },
  getHistoryAllRestStops(params) {
    return axios.get(REST_STOP_URIS.GET_LIST_HISTORY_REST_STOP, { params });
  },
  exportListRestStop(params) {
    const searchParams = new URLSearchParams(params);
    const link = `${
      REST_STOP_URIS.EXPORT_LIST_REST_STOP
    }?${searchParams.toString()}`;
    window.open(link);
  },
  addRestStop(data) {
    return axios.post(REST_STOP_URIS.ADD_REST_STOP, data);
  },
  editRestStop(data) {
    return axios.put(REST_STOP_URIS.EDIT_REST_STOP(data.id), data);
  },
  importContinueRestStop(data) {
    data.confirmImportRestStopId = data.ids;
    return axios.post(REST_STOP_URIS.IMPORT_CONTINUE, data);
  },
  getImportProgressRestStop(importId) {
    return axios.get(REST_STOP_URIS.GET_IMPORT_PROGRESS(importId));
  },
  requestSetStatusRestStop(data) {
    const payload = {
      statusStartDate:
        data.statusType == 1 && data.statusStartDate
          ? data.statusStartDate
          : null,
      statusEndDate:
        data.statusType == 1 && data.statusEndDate ? data.statusEndDate : null,
    };
    return axios.patch(REST_STOP_URIS.SET_STATUS(data.id), payload);
  },
  importRestStop(data) {
    return axios.post(REST_STOP_URIS.IMPORT, data);
  },
  downloadRestStopError(errorId) {
    return axios.get(REST_STOP_URIS.DOWNLOAD_ERROR_FILE(errorId), {
      responseType: "arraybuffer",
    });
  },
  downloadRestStopSuccess(errorId) {
    return axios.get(`${REST_STOP_URI_PREFIX}/download-error-file`, {
      responseType: "arraybuffer",
      params: {
        errorId,
        type: 1,
      },
    });
  },
  getConfirmNeededImportList(params) {
    return axios.get(REST_STOP_URIS.GET_CONFIRM_NEEDED_LIST(params.errorId), {
      params,
    });
  },
};



// WEBPACK FOOTER //
// ./src/services/rest-stop-service.js